module.exports = "/_next/static/images/WantToRetainCustomers-xs-a6fc51c573d65165e35538abb941bb0c.png";